import React, { useState } from "react";
import { useCallback } from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";
import DrawerPicketSupplementSupply from "../../components/drawers/picketSupplementSupply";

// Services
import { findAll } from "../../services/picketSupplementSupplyService";

export const PicketSupplementSupplyContext = createContext({
  dataList: { content: [], totalElements: 0, number: 0, size: 10 },
  isLoadingDataList: false,
  data: null,
  isDrawerVisible: false,
  refreshKey: 0,
});

export const PicketSupplementSupplyContextProvider = ({ children }) => {
  const [dataList, setDataList] = useState({ content: [], totalElements: 0, number: 0, size: 10 });
  const [data, setData] = useState(null);
  const [isLoadingDataList, setIsLoadingDataList] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const fetchData = useCallback(async (page = 1, size = 10, sorter = null, filters = "") => {
    setIsLoadingDataList(true);
    try {
      const {
        data: { results },
      } = await findAll({ groupId, farmId, page, size, sorter, filters });
      const content = results?.content ?? results ?? [];
      const total = results?.totalElements ?? content.length;
      setDataList({
        content,
        totalElements: total,
        number: results?.number ?? (page - 1),
        size: results?.size ?? size,
      });
    } catch (error) {
    } finally {
      setIsLoadingDataList(false);
    }
  }, [farmId, groupId]);

  const refreshData = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  const openDrawer = useCallback((data = null) => {
    if (data) setData(data);
    setIsDrawerVisible(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setData(null);
    setIsDrawerVisible(false);
  }, []);

  const switchIsLoading = () => {
    setIsLoadingDataList((old) => !old);
  };

  return (
    <PicketSupplementSupplyContext.Provider
      value={{
        dataList,
        fetchData,
        refreshData,
        refreshKey,
        data,
        isLoadingDataList,
        isDrawerVisible,
        openDrawer,
        closeDrawer,
        switchIsLoading,
      }}
    >
      {children}
      <DrawerPicketSupplementSupply />
    </PicketSupplementSupplyContext.Provider>
  );
};
